jQuery(document).ready(function($) {
    const $firstItem = $('.rank-math-list-item').first();
    $firstItem.addClass('active');
    $firstItem.find('.rank-math-answer').show();

    $('.rank-math-question').on('click', function() {
        const $item = $(this).closest('.rank-math-list-item');
        const $answer = $item.find('.rank-math-answer');

        $('.rank-math-list-item.active').not($item).each(function() {
            $(this).find('.rank-math-answer').slideUp(300);
            $(this).removeClass('active');
        });

        $answer.slideToggle(300);
        $item.toggleClass('active');
    });
});